export const branding = {
  company: {
    name: process.env.NEXT_PUBLIC_COMPANY_NAME ?? 'MoveHQ US',
    abbreviation: process.env.NEXT_PUBLIC_COMPANY_ABBR ?? 'MHQ',
  },
  product: {
    name: process.env.NEXT_PUBLIC_PRODUCT_NAME ?? 'MoveHQ Survey',
    abbreviation: process.env.NEXT_PUBLIC_PRODUCT_ABBR ?? 'MHQ',
  },
  crm: {
    name: process.env.NEXT_PUBLIC_CRM_NAME ?? 'MoveHQ CRM',
  },
  emails: {
    noReply: process.env.NEXT_PUBLIC_EMAIL_NO_REPLY ?? 'no-reply@movehq.us',
  },
  phones: {
    /**
     * Default phone numbers: (555) 555-5555 (one variable per usage domain)
     */
    support: process.env.NEXT_PUBLIC_PHONE_SUPPORT ?? '(555) 555-5555',
  },
  externalLinks: {
    depotHost: process.env.NEXT_PUBLIC_DEPOT_HOST ?? 'https://api.movehq.us',
    crmHost: process.env.NEXT_PUBLIC_CRM_HOST ?? 'https://crm.movehq.us',
  },
};

export type Branding = typeof branding;
export default branding;
